import { IClientComponentDefinition } from '@glidecms/deliver-core-dev/gd-module'

export const WMoreOnThisCCD: IClientComponentDefinition = {
  name: 'WMoreOnThis',
  load: () => import(/* webpackChunkName: 'WMoreOnThis' */ './w-more-on-this.component'),
}
